<script setup lang="ts">
    import { useCompanyStore } from '@Stores/company.store';
    import { useLocationStore } from '@Stores/location.store';
    import { GuidedShowcaseLayout } from '@Shared';
    import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
    import BlockedGraphic from '@Assets/images/blocked.svg';
    import ShowcaseImage from '@Components/shared/ShowcaseImage.vue';

    const companyImageBaseUrl = useCompanyImageBaseUrl();
    const companyStore = useCompanyStore();
    const locationStore = useLocationStore();
</script>

<template>
    <guided-showcase-layout
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :steps="['canceled']"
        :current-step="0">

        <div class="request-canceled-content">
            <app-form-content-layout>
                <img alt="Request Canceled"
                     class="canceled-graphic"
                     :src="BlockedGraphic" />

                <h2 bottomOffset="1rem">The sender canceled this request</h2>

                <p class="message">
                    This request is no longer active.
                </p>

                <p class="message">
                    This e-signature request is no longer active.

                    If you believe this was a mistake or need assistance, please contact your closing team or reach out to
                    <app-link link-url="mailto:support@certifid.com">
                        support@certifid.com
                    </app-link>.
                </p>

            </app-form-content-layout>
        </div>

        <template #branded>
            <showcase-image />
        </template>
    </guided-showcase-layout>
</template>

<style lang="scss" scoped>
    @use "certifid-v2-client-hub-styles" as *;

    .request-canceled-content {

        .canceled-graphic {
            width: 6.25rem;
            height: 7.25rem;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }

        .message {
            font-size: 1rem;
            line-height: 1.5;
        }
    }
</style>
